import React from "react";
import type { ConfirmOptions } from "@app/services/confirm/types";
import type { ApiOmpBoAvOperation } from "@src/api/bo";
import { BoOperationConfirmContent, type BoOperationConfirmField } from "./BoOperationConfirmContent";

export interface BuildBoOperationConfirmParams {
    operation: ApiOmpBoAvOperation;
    documentLabel: string;
    fields: BoOperationConfirmField[];
}

/**
 * Формирует опции app-level confirm для выполнения BO-операции.
 */
export function buildBoOperationConfirmOptions(params: BuildBoOperationConfirmParams): ConfirmOptions {
    const { operation, documentLabel, fields } = params;

    return {
        title: "Подтверждение операции",
        content: <BoOperationConfirmContent operation={operation} documentLabel={documentLabel} fields={fields} />,
        confirmText: "Выполнить",
        cancelText: "Закрыть",
    };
}
